export default {
  title: 'Dados do gestor'
}